import React, { Component } from 'react';
import { fromJS } from 'immutable';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as User from '../../../utils/userHelpers';
import * as Cart from '../../../utils/cartHelper';
import * as Orders from '../../../utils/ordersHelper';
import * as CartActions from '../../../actions/cartActions';
import * as OrdersActions from '../../../actions/ordersActions';
import Loader from '../../../components/commons/loader/loader';
import SweetAlert from 'sweetalert-react';
import * as Utils from '../../../utils/utils';
import withSizes from 'react-sizes';
import ProductDefaultImage from '../../../assets/images/product-default-image.jpg';

class CartPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cartItems: {},
      billDetails: {},
      showAlert: false,
      swalParams: {
        title: ""
      },
      discountMessage: '',
      isUserLoggedIn: User.isLoggedIn(),
      promoCodeInput: '',
      giftDelivery: Cart.getCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY) || false
    }

    this.loadCart = this.loadCart.bind(this);
    this.addressUpdated = this.addressUpdated.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.onChangeProductQuantity = this.onChangeProductQuantity.bind(this);
    this.onChangeTipPercent = this.onChangeTipPercent.bind(this);
    this.deleteProduct = this.deleteProduct.bind(this);
    this.checkOrderDetails = this.checkOrderDetails.bind(this);
    this.onApplyCoupon = this.onApplyCoupon.bind(this);
    this.onRemoveCoupon = this.onRemoveCoupon.bind(this);
    this.onChangeCustomTipValue = this.onChangeCustomTipValue.bind(this);
    this.handlePromoChange = this.handlePromoChange.bind(this);
    this.handleGiftToggle = this.handleGiftToggle.bind(this);
    this.getProductPrice = this.getProductPrice.bind(this);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.renderCartItemCard = this.renderCartItemCard.bind(this);
  }

  componentDidMount() {

    const isUserLoggedIn = User.isLoggedIn();
    this.setState({ isUserLoggedIn });
    this.loadCart({ skipOrderCheck: !isUserLoggedIn });
    window.scrollTo(0, 0);
    window.addEventListener('address_changed', this.addressUpdated);
  }

  componentWillUnmount() {
    window.removeEventListener('address_changed', this.addressUpdated);
    window.scrollTo(0, 0);
  }

  addressUpdated() {
    this.loadCart({ skipOrderCheck: !this.state.isUserLoggedIn });
  }

  render() {

    const { billDetails, swalParams, showAlert, isUserLoggedIn, promoCodeInput, giftDelivery } = this.state;
    const { isMobile, productsLoading, ordersLoading, cart } = this.props;
    const cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
      : [];

    const subTotalValue = (billDetails && billDetails.subTotal ? billDetails.subTotal : 0) - (billDetails && billDetails.CRV ? billDetails.CRV : 0);
    const tipPercent = billDetails && billDetails.tip ? billDetails.tip.percent : 0;
    const tipAmount = billDetails && billDetails.tip ? billDetails.tip.amount : 0;
    const tipOptions = [
      { label: '10%', value: 10 },
      { label: '15%', value: 15 },
      { label: '20%', value: 20 },
      { label: '25%', value: 25 },
      { label: 'No tip', value: 0 }
    ];

    return (
      <div className={`page cart-page ${isMobile ? 'mobile' : ''}`}>
        <div className="cart-shell">
          <h1 className="cart-page-title">Shopping Cart</h1>

          {(cartItemList.length > 0)
            ? (
              <React.Fragment>
                <div className="cart-body">
                  <div className="cart-items-stack">
                    {cartItemList.map(item => this.renderCartItemCard(item))}
                  </div>
                  <div className="summary-card">
                    <div className="summary-header">
                      <h3>Order Summary</h3>
                    </div>
                    <div className="summary-list">
                      <div className="summary-row">
                        <span>Subtotal</span>
                        <span>{this.formatCurrency(subTotalValue)}</span>
                      </div>
                      {billDetails && billDetails.discountByPromoCode ? (
                        <div className="summary-row discount-row">
                          <span>
                            Discount
                            {billDetails.discount && billDetails.discount.discountType == 1 ? (
                              <span className="summary-detail"> - FLAT {this.formatCurrency(billDetails.discountByPromoCode)} OFF</span>
                            ) : billDetails.discount && billDetails.discount.discount ? (
                              <span className="summary-detail"> - {billDetails.discount.discount * 100}% OFF</span>
                            ) : null}
                          </span>
                          <span>-{this.formatCurrency(billDetails.discountByPromoCode)}</span>
                        </div>
                      ) : null}
                      <div className="summary-row">
                        <span>CRV Fee</span>
                        <span>{this.formatCurrency(billDetails && billDetails.CRV)}</span>
                      </div>
                      <div className="summary-row">
                        <span>Tax (9.75%)</span>
                        <span>{this.formatCurrency(billDetails && billDetails.tax)}</span>
                      </div>
                      <div className="summary-row">
                        <span>Delivery Fee</span>
                        <span>{this.formatCurrency(billDetails && billDetails.deliveryFee)}</span>
                      </div>
                    </div>

                    <div className="tip-group">
                      <div className="tip-header">Add a tip</div>
                      <div className="tip-options">
                        {tipOptions.map(option => (
                          <button
                            key={option.value}
                            className={`tip-chip ${tipPercent === option.value ? 'active' : ''}`}
                            onClick={() => this.onChangeTipPercent(option.value)}
                            type="button"
                          >
                            {option.label}
                          </button>
                        ))}
                      </div>
                      <div className="tip-amount">
                        <label>Tip Amount</label>
                        <input type="text" readOnly value={this.formatCurrency(tipAmount)} />
                      </div>
                    </div>

                    <div className="promo-row">
                      <input
                        type="text"
                        value={promoCodeInput}
                        onChange={this.handlePromoChange}
                        placeholder="Promo code"
                        aria-label="Promo code"
                      />
                      <button type="button" onClick={() => this.onApplyCoupon(promoCodeInput)}>Apply</button>
                    </div>
                    {billDetails && billDetails.discount && billDetails.discount.code ? (
                      <div className="promo-feedback promo-applied">
                        <span>Applied: {billDetails.discount.code}</span>
                        <button type="button" onClick={() => this.onRemoveCoupon(null, billDetails.discount)}>Remove</button>
                      </div>
                    ) : null}
                    {this.state.discountMessage ? (
                      <div className="promo-feedback">{this.state.discountMessage}</div>
                    ) : null}

                    <div className="gift-row">
                      <label className="gift-checkbox">
                        <input
                          type="checkbox"
                          checked={giftDelivery}
                          onChange={this.handleGiftToggle}
                        />
                        <span className="custom-box" />
                        <div className="gift-copy">
                          <div className="gift-title">Send as Gift</div>
                          <div className="gift-sub">Add message & wrapping at checkout</div>
                        </div>
                      </label>
                    </div>

                    <div className="summary-total">
                      <span>Total</span>
                      <span className="total-value">{this.formatCurrency(billDetails && billDetails.total)}</span>
                    </div>
                  </div>
                </div>

                <div className="checkout-bar">
                  {isUserLoggedIn ? (
                    <Link to="/review-order" className="checkout-button">Proceed to Checkout</Link>
                  ) : (
                    <Link to="/signup" className="checkout-button">Sign up to Checkout</Link>
                  )}
                </div>
                {!isUserLoggedIn ? (
                  <div className="checkout-hint">
                    Already have an account? <Link to="/signin">Log in</Link> to finish your order.
                  </div>
                ) : null}
              </React.Fragment>
            )
            : this.renderEmptyCart()}
        </div>
        <Loader visibility={productsLoading || ordersLoading}/>
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams} onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    );
  }

  renderCartItemCard(product) {
    const price = this.getProductPrice(product);
    return (
      <div className="cart-item-card" key={product._id}>
        <div className="cart-thumb">
          <img src={product.image ? product.image : ProductDefaultImage} onError={(e) => e.target.src = ProductDefaultImage} alt={product.Description} />
        </div>
        <div className="cart-item-info">
          <div className="cart-item-title">{product.Description}</div>
          <div className="cart-item-subtext">{product.Size || product['Sub Description 2'] || 'Bottle'}</div>
          <div className="cart-item-price">{this.formatCurrency(price)}</div>
        </div>
        <div className="cart-item-actions">
          <div className="qty-pill">
            <button onClick={() => this.onChangeProductQuantity(product, product.quantity === 1 ? 1 : product.quantity - 1)} aria-label="Decrease quantity">-</button>
            <span>{product.quantity}</span>
            <button onClick={() => this.onChangeProductQuantity(product, product.quantity + 1)} aria-label="Increase quantity">+</button>
          </div>
          <button className="delete-item" onClick={() => this.deleteProduct(product._id)} aria-label="Remove item">
            <i className="fa fa-trash" />
          </button>
        </div>
      </div>
    )
  }

  renderEmptyCart() {

    return (
      <div className="empty-cart-container">
        <div className="title">Your shopping cart is empty</div>
        <div className="links">
          <Link to="/">Continue Shopping</Link>
        </div>
      </div>
    )
  }

  renderNoLoginMessage() {
    return (
      <div className="message-container">
        <div className="title">You are not logged in</div>
        <div className="links">
          <Link to="/signin">Please login to continue</Link>
        </div>
      </div>
    )
  }

  loadCart(options = {}) {
    const { skipOrderCheck } = options;
    this.props.dispatch(CartActions.loadCart());
    setTimeout(() => {
      this.checkOrderDetails(skipOrderCheck);
    }, 400);
  }

  checkOrderDetails(skipOrderCheck = false) {

    const {cart} = this.props;
    const cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
      : [];

    const shouldSkipOrderCheck = skipOrderCheck || !this.state.isUserLoggedIn;
    if (shouldSkipOrderCheck) {
      const billData = this.buildGuestBill(cartItemList);
      this.setState({ billDetails: billData });
      return;
    }

    let tempOrder = Orders.buildTempOrderData(cartItemList);
    console.log("TEMP_ORDER_PAYLOAD", tempOrder);
    this.props.dispatch(OrdersActions.createTempOrder(tempOrder, response => {
      console.log("ORDER_CHECK_RESPONSE", response);
      if (response.status) {
        let billData = Orders.calculateBill(response.data);
        this.setState({billDetails: billData});
      } else {
        // hack to remove promo code in case of errors
        this.props.dispatch(CartActions.removeCartAttribute(Cart.ATTRIBUTE_PROMO_CODE));
        this.setState({ showAlert: true, swalParams: {
          title: (response && response.data && response.data.error) ?
                    response.data.error.message : "Something went wrong!",
          type: "error",
          showConfirmButton: false
        }})
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))
  }

  buildGuestBill(cartItemList) {
    const tempOrder = Orders.buildTempOrderData(cartItemList);
    const tipAmount = tempOrder.tip || 0;
    const tipPercent = tempOrder.tipPercentage || 0;
    const taxableSubtotal = Math.max((tempOrder.subTotal || 0) - (tempOrder.CRV || 0), 0);
    const tax = parseFloat((taxableSubtotal * 0.0975).toFixed(2));
    const deliveryFee = 0;
    const total = parseFloat(((tempOrder.subTotal || 0) + tax + tipAmount + deliveryFee).toFixed(2));

    return {
      subTotal: tempOrder.subTotal || 0,
      CRV: tempOrder.CRV || 0,
      tax,
      deliveryFee,
      discountByPromoCode: 0,
      discount: {},
      tip: {
        percent: tipPercent,
        amount: tipAmount
      },
      total
    };
  }

  onChangeTipPercent(percent) {

    console.log("TIP_PERCENTAGE", percent);
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_TIP_PERCENT, {tipPercent: percent}));
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_CUSTOM_TIP_AMOUNT, {amount: 0}));
    setTimeout(() => {
      this.checkOrderDetails();
    }, 400);
  }

  onChangeCustomTipValue(value) {
    console.log("ATTRIBUTE_CUSTOM_TIP_AMOUNT", value);
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_TIP_PERCENT, {tipPercent: -1}));
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_CUSTOM_TIP_AMOUNT, {amount: value}));
    setTimeout(() => {
      this.checkOrderDetails();
    }, 400);
  }

  onApplyCoupon (coupon, callback) {
    const {cart} = this.props;
    const cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
      : [];

    let tempOrder = Orders.buildTempOrderData(cartItemList);
    this.props.dispatch(CartActions.applyDiscount(coupon, (res) => {
      if(res.status) {
        if (res.data) {
          if(!!callback) {
            callback(res.data)
          }
          if(res.data.data) {
            this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_PROMO_CODE, {promoCode: res.data.data}));
            setTimeout(() => {
              this.checkOrderDetails();
              this.setState({discountMessage:res.data.message});
            }, 400);
          } else {
            this.setState({discountMessage:res.data.message});
          }
        }
      }
    }));
  }

  onRemoveCoupon(coupon, discount) {
          this.setState({discountMessage:''});
          this.props.dispatch(CartActions.removeCartAttribute(Cart.ATTRIBUTE_PROMO_CODE, {promoCode: discount }));
          setTimeout(() => {
            this.checkOrderDetails();
      }, 400);
  }

  handlePromoChange(e) {
    this.setState({promoCodeInput: e.target.value});
  }

  onChangeProductQuantity(product, newQuantity) {

    console.log("Product quantity changed................", newQuantity);

    const {cart} = this.props;
    const cartItems = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? cart[Cart.ATTRIBUTE_CART_ITEMS]
      : [];

    if (product.quantity == 1 & newQuantity == 1) {
      this.deleteProduct(product._id);
    } else {
      let isRecommendedProduct = Utils.isRecommendedProduct(product)
      if (!isRecommendedProduct && (product['Qty'] < newQuantity)) {
        this.setState({showAlert: true, swalParams: {
          title: "We are in the process of restocking this item!",
          type: "warning",
          showConfirmButton: false
        }})
        // setTimeout(() => this.setState({showAlert: false}), 2000);
        return;
      }

      let copyOfItems = fromJS(cartItems).toJS();
      copyOfItems[product._id].quantity = newQuantity;
      this.setState({cartItems: copyOfItems})

      this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_CART_ITEM, {
        id: product._id,
        details: copyOfItems[product._id]
      }));
      setTimeout(() => {
        this.checkOrderDetails();
      }, 400);
    }

  }

  deleteProduct(productId, callback) {

    const {cart} = this.props;

    if (confirm('Are you want to remove this product?')) {
      this.props.dispatch(CartActions.removeCartAttribute(Cart.ATTRIBUTE_CART_ITEM, {itemId: productId}));
      setTimeout(() => {
        let items = Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS]);
        if (items && items.length > 0)
          this.checkOrderDetails();
      } , 400);
    }

  }

  updateCart(e) {

    let page = this.props.history.location.pathname.replace("\/", "");
    if (page == "cart")
      this.doOnCartChanged(e.detail)
  }

  handleGiftToggle(e) {
    const giftDelivery = e.target.checked;
    this.setState({giftDelivery});
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY, { giftDelivery }));
  }

  getProductPrice(product) {
    if (!product) return 0;
    if (product.OnSale || product.bundle) {
      return parseFloat(product.SalePrice || product.PriceB || 0);
    }
    return parseFloat(product.PriceB || 0);
  }

  formatCurrency(value) {
    const number = Number(value || 0);
    return `$${number.toFixed(2)}`;
  }
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    cart: state.getIn(['cart', 'cart']),
    user: state.getIn(['users', 'user']),
    ordersLoading: state.getIn(['orders', 'loading']),
    productsLoading: state.getIn(['products', 'loading']),
    error: state.getIn(['products', 'error'])
  };
})(CartPage));



// WEBPACK FOOTER //
// ./src/containers/billing/cart/CartPage.js